import { h, Component } from 'preact';
import IntervalSelector from '../interval-selector';
import style from './style';
import { intlDateNode } from '../../lib/util';
import { labelToTimeInterval } from '../../lib/intervals';
import { Text } from 'preact-i18n';
import { apiDate, sortData } from './utils';
import { Select, Option, Icon, ContainerSize } from '@cube/blocks';
import DataPanel from './data-panel';
import { getHistoricalData, getStockData } from './fetch-data';
import * as constants from './constants';
import { saveAs, supported } from '@os/save-as';
import { getStockPrice } from '@os/cloudquote';

export const INTL_NS = 'historical-data-panel.filter';

export default class Filter extends Component {
	state = {
		view: {
			value: 'Historical Prices'
		},
		frequency: 'daily',
		interval: '1M',
		symbolTypeCode: null
	};

	cacheData = {};

	viewChange = view => {
		if (view.value === 'Dividends / Splits') {
			this.setState({
				view,
				data: null,
				interval: 'MAX',
				start: '1900-01-01'
			});
		}
		else {
			this.setState({
				view,
				data: null
			});
		}
		this.getData();
	};

	changeFrequency = v => {
		let { columns, rows, years } = this.cacheData,
			daysInWeek = 5,
			value = (v && v.value) || this.state.frequency;

		switch (value) {
			case 'weekly':
				rows = rows.filter((row, i) => i % daysInWeek === 0);
				break;
			case 'monthly':
				rows = [];
				Object.keys(years).forEach(year => {
					Object.keys(years[year]).forEach(month => {
						rows.push(years[year][month][0]);
					});
				});
				rows = sortData({ columns, rows }).rows;
				break;
		}

		this.setState({
			data: {
				historical: {
					columns,
					rows
				}
			},
			frequency: value
		});
	};

	getStockType = symbol => {
		getStockPrice(symbol).then(({ rows }) => {
			if (rows && rows[0]) {
				this.setState({ symbolTypeCode: rows[0].SecurityTypeCode });
			}
			else {
				this.setState({ symbolTypeCode: null });
			}
		});
	};

	getData = props => {
		let { start, end, interval, view } = this.state, { symbol } = props || this.props;

		if (view.value === 'Historical Prices') {
			getHistoricalData({ symbol, start, end, interval }).then(({ start, end, cacheData }) => {
				this.cacheData = cacheData;
				this.setState({ start, end }, this.changeFrequency);
			});
		}
		else {
			getStockData({ symbol, start, end }).then(data => this.setState({ data }));
		}
	};

	// will assemble all the data into a csv format
	assembleCsv = data => {
		let heading = data.columns.join(',');
		let rows = data.rows.map(row => row.join(','));
		let body = rows.join('\n');
		return [heading, body].join('\n');
	};

	// will hide the download link if the browser is unsupported
	downloadLink = () =>
		supported() &&
		<div class={style.item}>
			<Icon class={style.icon} name="download-cube" />
			<a href="#" onclick={this.downloadData}>
				<Text id={`${INTL_NS}.downloadData`}>Download Data</Text>
			</a>
		</div>;

	// called when the user clicks the download link, initiates serving the file
	downloadData = () => {
		let { data } = this.state;
		let { symbol } = this.props;
		saveAs(this.assembleCsv(data.historical), `${symbol}.csv`, 'text/csv');
	};

	handleSelectInterval = (timerange, interval, props = this.props) => {
		// apiDate cannot accept -Infinity so we're passing Jan 1, 1900 as the start
		let apiStart = interval && interval.value === 'MAX' ? -2208970800000 : timerange[0];
		timerange = apiDate({ start: apiStart, end: timerange[1] });

		this.setState({
			end: timerange.end,
			start: timerange.start,
			data: null,
			interval: (interval && interval.value) || this.state.interval
		});

		this.getData(props);
	};

	componentWillMount() {
		let time = labelToTimeInterval(this.state.interval);
		this.handleSelectInterval(time);
		this.getStockType(this.props.symbol);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			let time = labelToTimeInterval(this.state.interval);
			this.handleSelectInterval(time, null, nextProps);
		}
	}

	render({ ...props }, { view, start, end, frequency, data, interval, symbolTypeCode }) {
		return (
			<div>
				<div class={style.filter}>
					{this.downloadLink()}
					<Item id={`${INTL_NS}.timePeriod`} label="time period">
						<IntervalSelector
							select
							scaled={false}
							class={style.intervalSelector}
							buttonClass={style.selectButton}
							disabled={!data}
							interval={interval}
							labels={constants.TIMEPERIODS}
							displayValue={[intlDateNode(start), ' - ', intlDateNode(end)]}
							customInterval={[]}
							onSelect={this.handleSelectInterval}
						/>
					</Item>
					<Item label={`${INTL_NS}.view`}>
						<Select
							buttonClass={style.selectButton}
							disabled={!data}
							value={view.value}
							onChange={this.viewChange}
							iconPosition="right"
						>
							{constants.VIEWS.map(v => (
								<Option
									title={<Text id={`${INTL_NS}.views.${v.substring(0, 3).toLowerCase()}`} />}
									value={v}
								/>
							))}
						</Select>
					</Item>
					{view.value === 'Historical Prices' &&
						<Item label={`${INTL_NS}.frequency`}>
							<Select
								buttonClass={style.selectButton}
								disabled={!data}
								value={frequency}
								onChange={this.changeFrequency}
								iconPosition="right"
							>
								{constants.FREQUENCY.map(v => (
									<Option title={<Text id={`${INTL_NS}.frequencies.${v}`} />} value={v} />
								))}
							</Select>
						</Item>}
				</div>
				<ContainerSize height={false}>
					<DataPanel view={view} data={data} symbolTypeCode={symbolTypeCode} {...props} />
				</ContainerSize>
			</div>
		);
	}
}

export const Item = ({ label, id, children, ...props }) => (
	<div class={style.item}>
		<span class={style.label}>
			<Text id={id || label}>{label}</Text>
		</span>
		{children}
	</div>
);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/historical-data-panel/filter.js